/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 16:26:04
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/TextAndEditIcon/index.tsx
 */
import React from 'react';
import css from './css.less';

import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import EditDeleteIconContainer from '../EditDeleteIconContainer';

const TextAndEditIcon = (props) => {
  const {
    icon,
    name,
    onClick,
    additional,
    containerClassName,
    onDelete,
    warningModalTitle,
    warningModalContent,
    disabled,
    displayWarningModalWhenDeleting,
  } = props;
  return (
    <EditDeleteIconContainer
      disabled={disabled}
      frontPart={
        <React.Fragment>
          <div className={css.sku}>
            <NoWrapContainer>
              <GlobalTooltip title={name}>
                {icon}
                {name}
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        </React.Fragment>
      }
      onClick={onClick}
      onDelete={onDelete}
      containerClassName={containerClassName}
      additional={additional}
      displayWarningModalWhenDeleting={displayWarningModalWhenDeleting}
      warningModalContent={warningModalContent}
      warningModalTitle={warningModalTitle}
    />
    // <div className={`${css.container} ${containerClassName || ''}`}>
    //   <div className={css.contentContainer}>

    //   </div>
    //   {additional}
    //   <FormOutlined className={css.icon} onClick={onClick} />
    //   {onDelete && <DeleteIcon onDelete={onDelete} />}
    // </div>
  );
};
export default TextAndEditIcon;
